module.exports = __webpack_public_path__ + "media/swiftly-610.c34ce9e8.ogg";